// Program içi onay / metin girişi penceresi: await confirmDialog({...}) -> true/false, await promptDialog({...}) -> metin | null
import { useEffect, useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';
import { Textarea } from './ui/textarea';

let openFn = null;
let pending = null;
const request = (opts) => new Promise((resolve) => {
  const req = { ...opts, resolve };
  if (openFn) openFn(req); else pending = req;
});
export const confirmDialog = (opts) => request(opts);
export const promptDialog = (opts) => request({ ...opts, prompt: true });

export const ConfirmHost = () => {
  const [req, setReq] = useState(null);
  const [text, setText] = useState('');
  useEffect(() => {
    openFn = (r) => { setText(''); setReq(r); };
    if (pending) { openFn(pending); pending = null; }
    return () => { openFn = null; };
  }, []);
  const done = (ok) => {
    req?.resolve(req.prompt ? (ok ? text : null) : ok);
    setReq(null);
  };
  return (
    <AlertDialog open={!!req} onOpenChange={(o) => !o && done(false)}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{req?.title || 'Emin misiniz?'}</AlertDialogTitle>
          {req?.description && <AlertDialogDescription>{req.description}</AlertDialogDescription>}
        </AlertDialogHeader>
        {req?.prompt && (
          <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder={req.placeholder || ''} rows={3} autoFocus data-testid="confirm-dialog-input" />
        )}
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => done(false)} data-testid="confirm-dialog-cancel">{req?.cancelLabel || 'Vazgeç'}</AlertDialogCancel>
          <AlertDialogAction onClick={() => done(true)} className={req?.tone === 'primary' ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-rose-600 hover:bg-rose-700'} data-testid="confirm-dialog-ok">{req?.confirmLabel || 'Evet'}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
